module.exports = __webpack_public_path__ + "img/2025-07-21b_4.f07b0252.jpg";